import { createUseStyles } from '../../theme/theming';

const useSectionStyles = createUseStyles((theme) => ({
  section: {
    padding: ({ isMobile } = {}) =>
      isMobile
        ? `${theme.spacing.padding.regular}px ${theme.spacing.padding.small}px`
        : `${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`,
    backgroundColor: theme?.colors?.background2,

    '&, & *, & *:before, & *:after': {
      fontFamily: theme?.typography?.fontFamily,
      boxSizing: 'border-box'
    },
    '& h2,& h3,& p': {
      margin: '0'
    }
  },
  sectionContainer: {
    maxWidth: ({ containerWidth } = {}) => containerWidth
  },
  subHeading: {
    fontSize: theme.typography.fontSize.subHead,
    marginBottom: '8px',
    color: theme?.colors?.font3,
    wordBreak: 'break-word',
    textTransform: 'uppercase',
    letterSpacing: '3px'
  },
  title: {
    fontSize: theme.typography.fontSize.h2,
    fontWeight: theme.typography.fontWeight.bold,
    lineHeight: 'normal',
    margin: '0',
    color: theme?.colors?.font3,
    wordBreak: 'break-word',
    marginBottom: theme.spacing.margin.tiny
  },
  textContent: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '48px',
    padding: '32px 0px'
  },
  textPara: {
    color: theme?.colors?.font3,
    wordBreak: 'break-word',
    fontSize: theme.typography.fontSize.body,
    lineHeight: '24px'
  },

  '@media screen and (max-width: 767px)': {
    textContent: {
      display: 'flex',
      flexDirection: 'column',
      lineHeight: '22px',
      gap: '16px',
      padding: '16px 0px'
    },
    subHeading: {
      textAlign: 'center'
    },
    title: {
      textAlign: 'center'
    }
  }
}));

export default useSectionStyles;
